/**
 * slideId.ts
 * Utilities for generating and managing deterministic slide identifiers.
 *
 * Office.js does not expose a stable slide ID across sessions out of the box.
 * We generate a UUID once and store it in document settings, keyed by
 * the slide's 1-based index at the time of injection.
 *
 * The UUID is persisted in settings as:
 *   `slideId_index_{slideIndex}` → "gh_<uuid>"
 */

const PREFIX = 'gh_';

/**
 * Generates a new slide ID string.
 */
export function generateSlideId(): string {
  // crypto.randomUUID() is available in all modern browsers + Webview2
  return `${PREFIX}${globalThis.crypto.randomUUID()}`;
}

/**
 * Builds the document settings key for a slide's stored ID.
 * Key format: "slideId_index_{n}"
 */
export function buildSlideSettingsKey(slideIndex: number): string {
  return `slideId_index_${slideIndex}`;
}

/**
 * Validates that a string looks like a GuroHub slide ID.
 */
export function isGuroSlideId(id: string): boolean {
  return id.startsWith(PREFIX) && id.length > PREFIX.length;
}
